import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { keyframes } from '@emotion/react';
import { styled } from '@mui/system';
import { valHooks } from 'jquery';

const slide = keyframes`
  from {
    left: 100%;
  }
  to {
    left: calc(var(--width) * -1);
  }
`;

const CarouselContainer = styled(Box)({
    display: 'grid',
    placeItems: 'center',
    height: '160px',
    backgroundColor: '#000',
});

const Carousel = styled(Box)({
    width: '100%',
    height: 'var(--height)',
    overflow: 'hidden',
    maskImage: 'linear-gradient(to right, transparent, #000 10%, 90%, transparent)',
    '&:hover .carousel__item': {
        animationPlayState: 'paused !important',
       
    },
});

const CarouselList = styled(Box)({
    display: 'flex',
    width: '100%',
    minWidth: 'calc(var(--width) * var(--quantity))',
    position: 'relative',
});

const CarouselItem = styled(Box)({
    width: 'var(--width)',
    height: 'var(--height)',
    position: 'absolute',
    left: '100%',
    textAlign: 'center',
    fontSize: '2rem',
    color: 'white',
    animation: `${slide} var(--duration) linear infinite`,
    animationDelay: 'calc((var(--duration) / var(--quantity)) * (var(--position) - var(--quantity))) !important',
});

const StarSeparator = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 10px',
    color: '#e4b247', // Gold color
    fontSize: '2rem',
});

const items = [
    {
        name: 'Party'
    },
    {
        img: '/images/icon/star-icon-color.svg',
    },
    {
        name: 'Work'
    },
    {
        img: '/images/icon/star-icon-color.svg',
    },
    {
        name: 'Business'
    },
    {
        img: '/images/icon/star-icon-color.svg',
    },
    {
        name: 'Casual'
    },
    {
        img: '/images/icon/star-icon-color.svg',
    },
    {
        name: 'Formal'
    },
    {
        img: '/images/icon/star-icon-color.svg',
    }
];

const CarouselComponent = () => {
    const theme = useTheme();

    return (
        <CarouselContainer>
            <Carousel className="carousel" sx={{ '--width': '250px', '--height': '66px', '--quantity': 10, '--duration': '15s' }}>
                <CarouselList className="carousel__list">
                    {items.map((item, index) => (
                        <React.Fragment key={index}>
                            <CarouselItem className="carousel__item" sx={{ '--position': index + 1 }}>
                                {
                                    item.name ? 
                                    <Typography variant="h6" sx={{ fontFamily: theme.palette.typography.fontFamily1, fontSize: '30px' }}>{item.name}</Typography> :
                                    <img src={item.img}/>
                                }
                            </CarouselItem>
                        </React.Fragment>
                    ))}
                </CarouselList>
            </Carousel>
        </CarouselContainer>
    );
};

export default CarouselComponent;
